import './CreateAttachVersionExecutor.scss';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IFileData } from '@srm/ui/types/IFileData';
import InputFile from '@srm/ui/input-file';
import { MAX_FILE_SIZE } from '@/constants';
import { AttachActionsService } from '@services/actions/AttachActionsService';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { ICreateAttachVersionProps } from './ICreateAttachVersionProps';

export const CreateAttachVersionModal: React.FC<ICreateAttachVersionProps> = (props: ICreateAttachVersionProps) => {
    const [selectedFiles, setSelectedFiles] = useState<IFileData[]>();
    const [fileName, setFileName] = useState<string>('');
    const [acceptExtension, setAcceptExtension] = useState<string>('*');

    const formMethods = useForm();

    const { errorText, isBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        initialBusy: false,
        resetErrorOnSubmit: true,
        submit: () => new AttachActionsService(props.docId, '-1').createAttachVersion(selectedFiles![0].file, props.attachId),
    });

    useEffect(() => {
        const rowData = Array.isArray(props.rowData) ? props.rowData[0] : props.rowData;
        const fields = rowData?.fields;
        const name: string = fields?.['AttachmentFileName'] ?? fields?.['AttachmentTitle'] ?? '';
        const splitFileName = name.split('.');
        let ext: string;
        if (!splitFileName[splitFileName.length - 1]) {
            ext = '*';
        } else {
            ext = `.${splitFileName[splitFileName.length - 1]}`;
        }

        setFileName(name);
        setAcceptExtension(ext);
    }, [props.rowData]);

    const setFile = (file: IFileData[]) => {
        setSelectedFiles(file);
    };

    const onSubmit = () => {
        if (!selectedFiles || selectedFiles.length === 0) return;

        return okClick();
    };

    const modalContainerProps: IModalContainerProps = {
        header: 'Создать версию',
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        hasUnsavedInput: () => (selectedFiles?.length ?? 0) > 0,
        okButtonDisabled: !selectedFiles || selectedFiles.length === 0,
        errorText: errorText,
        formMethods: formMethods,
        onSubmit: onSubmit,
        onCancel: cancelClick,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <div>
                <InputFile
                    className="CreateAttachVersion__SelectFilesInput"
                    onChange={setFile}
                    placeholderButton={`Выберите версию файла с устройства`}
                    placeholderDropzone={`Перетащите версию файла ${fileName} в эту область`}
                    maxSize={MAX_FILE_SIZE}
                    multiple={false}
                    accept={acceptExtension}
                />
            </div>
        </ModalContainer>
    );
};
